<template>
  <span>
    <el-dropdown id="report-dropdown" @command="handleCommand">
      <el-button class="button-report" type="success" plain size="mini">{{ $t('palletReceipt.reports') }}<i class="el-icon-arrow-down el-icon--right" /></el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item id="print-redeemed-pallet-receipts" command="printRedeemedPalletReceipts"><span class="report-option">{{ $t('palletReceipt.redeemedPallets') }}</span></el-dropdown-item>
        <el-dropdown-item id="print-received-pallet-receipts" command="printReceivedPalletReceipts"><span class="report-option">{{ $t('palletReceipt.receivedPallets') }}</span></el-dropdown-item>
        <el-dropdown-item id="print-absent-pallet-receipts" command="printAbsentPalletReceipts"><span class="report-option">{{ $t('palletReceipt.absentPallets') }}</span></el-dropdown-item>
        <el-dropdown-item id="print-current-balance" command="printCurrentBalance"><span class="report-option">{{ $t('palletReceipt.currentBalance') }}</span></el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <print-redeemed-dialog :display-dialog="displayRedeemedDialog" @close-dialog="displayRedeemedDialog=false" />
    <print-received-dialog :display-dialog="displayReceivedDialog" @close-dialog="displayReceivedDialog=false" />
    <print-current-balance-dialog :display-dialog="displayCurrentBalanceDialog" @close-dialog="displayCurrentBalanceDialog=false" />
    <print-absent-pallet-summary-dialog :display-dialog="displayAbsentDialog" @close-dialog="displayAbsentDialog=false" />
  </span>
</template>

<script>
import PrintRedeemedDialog from './PrintRedeemedDialog';
import PrintReceivedDialog from './PrintReceivedDialog';
import PrintCurrentBalanceDialog from './PrintCurrentBalanceDialog';
import PrintAbsentPalletSummaryDialog from './PrintAbsentPalletSummaryDialog';

export default {
  name: 'Reports',
  components: {
    PrintAbsentPalletSummaryDialog,
    PrintRedeemedDialog,
    PrintReceivedDialog,
    PrintCurrentBalanceDialog,
  },
  data() {
    return {
      displayRedeemedDialog: false,
      displayReceivedDialog: false,
      displayCurrentBalanceDialog: false,
      displayAbsentDialog: false
    };
  },
  methods: {
    handleCommand(command) {
      if (command === 'printRedeemedPalletReceipts') {
        this.handlePrintRedeemedPalletReceipts();
      } else if (command === 'printReceivedPalletReceipts') {
        this.handlePrintReceivedPalletReceipts();
      } else if (command === 'printCurrentBalance') {
        this.handlePrintCurrentBalance();
      } else if (command === 'printAbsentPalletReceipts') {
        this.handlePrintAbsentPalletReceipts();
      }
    },
    handlePrintRedeemedPalletReceipts() {
      this.displayRedeemedDialog = true;
    },
    handlePrintReceivedPalletReceipts() {
      this.displayReceivedDialog = true;
    },
    handlePrintCurrentBalance() {
      this.displayCurrentBalanceDialog = true;
    },
    handlePrintAbsentPalletReceipts() {
      this.displayAbsentDialog = true;
    },
  }
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.button-report  {
  margin-left: 10px;
}

.report-option {
  color: #008d00;
}
</style>
